(ns manage.resource.campaign-insights
  (:require [common.url-template :as url-tpl]
            [re-frame.core :as rf]))

(rf/reg-event-fx :resource.campaign-insights/get-graph-data
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ params]]
    {:db (assoc db :resource.campaign-insights {:state :pending :data {}})
     :fx [[:http {:requests [{:id :impressions-clicks
                              :method :get
                              :uri (url-tpl/render :measure-api/campaign-insights-impressions-clicks url-context)
                              :headers {"Authorization" (:resource.user/token cofx)}
                              :params params}
                             {:id :video-quartiles
                              :method :get
                              :uri (url-tpl/render :measure-api/campaign-insights-video-quartiles url-context)
                              :headers {"Authorization" (:resource.user/token cofx)}
                              :params params}
                             {:id :variant-average-impressions
                              :method :get
                              :uri (url-tpl/render :measure-api/campaign-insights-variant-average-impressions url-context)
                              :headers {"Authorization" (:resource.user/token cofx)}
                              :params params}
                             {:id :variant-average-clicks
                              :method :get
                              :uri (url-tpl/render :measure-api/campaign-insights-variant-average-clicks url-context)
                              :headers {"Authorization" (:resource.user/token cofx)}
                              :params params}
                             {:id :variant-average-ctr
                              :method :get
                              :uri (url-tpl/render :measure-api/campaign-insights-variant-average-ctr url-context)
                              :headers {"Authorization" (:resource.user/token cofx)}
                              :params params}]
                  :on-success [:resource.campaign-insights/get-graph-data-success]
                  :on-failure [:resource.campaign-insights/get-graph-data-failure]}]]}))

(rf/reg-event-db :resource.campaign-insights/get-graph-data-success
  (fn [db [_ response]]
    (assoc db :resource.campaign-insights {:data response
                                           :state :success})))

(rf/reg-event-db :resource.campaign-insights/get-graph-data-failure
  (fn [db [_ _]]
    (assoc db :resource.campaign-insights {:state :failure})))

(rf/reg-sub :resource.campaign-insights
  (fn [db]
    (:resource.campaign-insights db)))

(rf/reg-sub :resource.campaign-insights/state
  :<- [:resource.campaign-insights]
  (fn [campaign-insights]
    (:state campaign-insights)))

(rf/reg-sub :resource.campaign-insights/data
  :<- [:resource.campaign-insights]
  (fn [campaign-insights]
    (:data campaign-insights)))

(rf/reg-sub :resource.campaign-insights/impressions-clicks
  :<- [:resource.campaign-insights/data]
  (fn [campaign-insights]
    (:impressions-clicks campaign-insights)))

(rf/reg-sub :resource.campaign-insights/video-quartiles
  :<- [:resource.campaign-insights/data]
  (fn [campaign-insights]
    (:video-quartiles campaign-insights)))

(rf/reg-sub :resource.campaign-insights/variant-average-impressions
  :<- [:resource.campaign-insights/data]
  (fn [campaign-insights]
    (:variant-average-impressions campaign-insights)))

(rf/reg-sub :resource.campaign-insights/variant-average-clicks
  :<- [:resource.campaign-insights/data]
  (fn [campaign-insights]
    (:variant-average-clicks campaign-insights)))

(rf/reg-sub :resource.campaign-insights/variant-average-ctr
  :<- [:resource.campaign-insights/data]
  (fn [campaign-insights]
    (:variant-average-ctr campaign-insights)))
